import React from 'react';
import Radio from 'src/ui/library/Radio';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

const RadioControl = props => {
  const { listOptions, label, helpText, ...otherProps } = props;
  const options = listOptions && listOptions.map(item => ({ label: item.displayText, value: item.lookUpBindValue }));
  let labelText = label;

  if (label && helpText) {
    labelText = <InfoTooltip toolTipText={helpText} labelText={labelText} inlineLabel />;
  }

  return <Radio {...otherProps} options={options} label={labelText} />;
};

export default WithHeader(RadioControl);
